export default (pathname, url) => {
  const baseUrl = pathname.split("/")[1];

  return `/${baseUrl}/` === url;
};
